import { z } from "zod";
import { TenantSchema } from "../../models/tenant.schema";
import { UserWRoleSchema } from "../../models/user.schema";

export const PrivateTenantControllerResponseSchema = {
  createNewTenant: TenantSchema,

  accessTenant: z.boolean(),

  getUsersInTenant: UserWRoleSchema.array(),

  getAccessibleTenants: TenantSchema.array(),

  addUserToTenant: z.boolean(),

  removeUserFromTenant: z.boolean(),

  getTenant: TenantSchema.nullable(),

  getTenantByFriendlyId: TenantSchema.nullable(),

  updateTenant: TenantSchema,
};
